import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { AiFillShopping, AiFillHeart } from "react-icons/ai";
import logo from "../assets/apna-plaza-logo.png";

const Footer = ({ className = "", style = {} }) => {
  const { card_product_count, wishlist_count } = useSelector(
    (state) => state.card,
  );
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const [isHeaderScrolledUp, setIsHeaderScrolledUp] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      // Set isHeaderScrolledUp to true when the header is scrolled up (you can adjust the threshold)
      setIsHeaderScrolledUp(scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <footer
      className={`bg-primary md:hidden sm:hidden ${className}`}
      style={style}
    >
      <div className="w-[85%] flex flex-wrap justify-between mx-auto border-b py-16 md-lg:pb-10 sm:pb-6">
        <div className="w-[30%] lg:w-4/12 sm:w-full">
          <div className="flex flex-col gap-4">
            <Link className="flex items-center gap-1" to="/">
              <img className="w-[55%]" src={logo} alt="Logo" />
            </Link>
            <p className="text-slate-200">
              A volunteer led initiative connecting Gul Plaza tarders affected
              by the fire with customer who want to support their recovery.
            </p>
            <ul className="flex flex-col gap-2 text-slate-200">
              {/* <li>Phone : +92</li> */}
              <li>Email : apnaplaza.store@gmail.com</li>
            </ul>
          </div>
        </div>
        <div className="w-[30%] lg:w-8/12 sm:w-full">
          <div className="flex gap-24 justify-center sm:justify-start sm:mt-6 w-full">
            <div>
              <h2 className="font-bold text-slate-200 text-lg mb-3">
                Quick Links
              </h2>
              <div className="flex justify-between gap-[80px] lg:gap-[40px]">
                <ul className="flex flex-col gap-2 text-slate-200 text-sm">
                  <li className="hover:translate-x-3 transition-transform duration-300">
                    <Link to="/shops">Shops</Link>
                  </li>
                  <li className="hover:translate-x-3 transition-transform duration-300">
                    <Link to="/products">Products</Link>
                  </li>
                  {/* <li className="hover:translate-x-3 transition-transform duration-300">
                    <Link to="/about">About Us</Link>
                  </li> */}
                  <li className="hover:translate-x-3 transition-transform duration-300">
                    <Link to="/contact">Contact Us</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <h2 className="font-bold  text-slate-200  text-lg mb-3">
                Stay Connected
              </h2>
              <div className="flex justify-between gap-[80px] lg:gap-[40px]">
                <ul className="flex flex-col gap-2 text-slate-200 text-sm">
                  <li className="flex group items-center gap-2 cursor-pointer hover:translate-x-3 transition-transform duration-300">
                    <a href="https://www.instagram.com/apnaplazaofficial/" target="_blank" rel="noopener noreferrer">
                      <span className="w-[30px] text-[16px] text-secondary h-[30px] group-hover:bg-secondary group-hover:text-white flex justify-center items-center bg-white rounded-full">
                        <FaInstagram />
                      </span>
                    </a>{" "}
                    Instagram
                  </li>
                  <li className="flex group items-center gap-2 cursor-pointer hover:translate-x-3 transition-transform duration-300">
                    <a href="https://www.facebook.com/share/1CEE1bwQPz/">
                      <span className="w-[30px] text-[16px] text-secondary h-[30px] group-hover:bg-secondary group-hover:text-white flex justify-center items-center bg-white rounded-full">
                        <FaFacebookF />
                      </span>
                    </a>{" "}
                    Facebook
                  </li>
                  {/* <li className="flex group items-center gap-2 cursor-pointer hover:translate-x-3 transition-transform duration-300">
                    <a href="/">
                      <span className="w-[30px] text-[16px] text-secondary h-[30px] group-hover:bg-secondary group-hover:text-white flex justify-center items-center bg-white rounded-full">
                        <FaXTwitter />
                      </span>
                    </a>{" "}
                    X
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="w-[25%] lg:w-full lg:mt-6">
          <div className="w-full flex flex-col justify-start gap-3">
            <h2 className="font-bold  text-slate-200  text-lg">Verification</h2>
            <span className=" text-slate-200 ">
              All shops listed on Apna Plaza have been verified to ensure a safe
              and trustworthy shopping experience for our customers.
            </span>
          </div>
        </div>
      </div>
      <div className="w-[85%] flex flex-wrap justify-center items-center text-slate-200 mx-auto py-5 text-center">
        <span>
          Copyright ©2026 All rights reserved | by{" "}
          {/* <a
            href="https://www.linkedin.com/in/nomanabdullah/"
            target="_blank"
            rel="noreferrer"
            className="underline"
          > */}
          Team Apna Plaza
          {/* </a> */}
        </span>
      </div>

      <div
        className={`fixed translate-y-[-189%] drop-shadow-xl  md-lg:hidden w-[60px] bottom-3 h-[110px] right-2 bg-primary rounded-full  p-2 ${
          isHeaderScrolledUp ? "visible" : "invisible"
        }`}
      >
        <div className="w-full h-full flex gap-3 flex-col justify-center items-center">
          <div
            onClick={() => navigate(userInfo ? "/card" : "/login")}
            className="relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] rounded-full bg-[#e2e2e2]"
          >
            <span className="text-xl text-orange-500">
              <AiFillShopping />
            </span>
            {card_product_count !== 0 && (
              <div className="w-[20px] h-[20px] absolute bg-primary rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px]">
                {card_product_count}
              </div>
            )}
          </div>
          <div
            onClick={() =>
              navigate(userInfo ? "/dashboard/my-wishlist" : "/login")
            }
            className="relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] rounded-full bg-[#e2e2e2]"
          >
            <span className="text-xl text-red-500">
              <AiFillHeart />
            </span>
            {wishlist_count !== 0 && (
              <div className="w-[20px] h-[20px] absolute bg-primary rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px]">
                {wishlist_count}
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
